var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoadingImagesFromSpace)?_c('VehicleCardGallery',{staticStyle:{"max-width":"15rem !important"},attrs:{"images":_vm.vehicleImages,"showThumbnail":false,"typeList":'list'}}):_c('div',[_vm._v("loading")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }